"use strict";
/**
 * The zod-free half of the DSL.
 *
 * Everything in this file is a plain function or a type. Nothing here imports
 * zod, and nothing may start to — because this is what the *runtime* entry
 * (`@stem/lab-schema/runtime`) re-exports, and that entry exists so a learner
 * opening a lab does not download a schema validator they will never run.
 *
 * The split is worth about 100 kB uncompressed on the lab chunk, which on the
 * connections this platform is designed for is roughly the difference between
 * a lab that opens and one that times out. The server and the authoring
 * harness import the full entry and get the schemas; the browser running a
 * lab imports this one.
 *
 * The types are declared here and the zod schemas are checked *against* them
 * in `checks.ts` and `dataset.ts`, so the two cannot drift without a compile
 * error.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GRAPH_KINDS = exports.RENDER_TIERS = void 0;
exports.tierRank = tierRank;
exports.tierSatisfies = tierSatisfies;
exports.datasetTotal = datasetTotal;
exports.datasetCounts = datasetCounts;
exports.tallyGroups = tallyGroups;
exports.scriptMaxScore = scriptMaxScore;
exports.scriptBytes = scriptBytes;
exports.findDataset = findDataset;
exports.findStep = findStep;
exports.RENDER_TIERS = ['text', '2d', '2.5d', '3d'];
function tierRank(tier) {
    return exports.RENDER_TIERS.indexOf(tier);
}
/** True when `available` can render something authored for `required`. */
function tierSatisfies(available, required) {
    return tierRank(available) >= tierRank(required);
}
exports.GRAPH_KINDS = ['bar', 'pictograph', 'line', 'pie'];
/** Total observations — the "40 vehicles" in "40 animated vehicles on a road". */
function datasetTotal(dataset) {
    return dataset.categories.reduce((sum, category) => sum + category.count, 0);
}
/** `{ buses: 10, lorries: 6, … }` — what a tally or table check compares against. */
function datasetCounts(dataset) {
    return Object.fromEntries(dataset.categories.map(category => [category.key, category.count]));
}
/** The tally marks a learner would draw, as groups of five plus a remainder. */
function tallyGroups(count) {
    return { fives: Math.floor(count / 5), remainder: count % 5 };
}
/** Sum of every step's points — the denominator every score is reported over. */
function scriptMaxScore(script) {
    return script.steps.reduce((total, step) => total + (step.scoring.points || step.checks.reduce((sum, check) => sum + check.points, 0)), 0);
}
/** Total bytes of the lab's assets, for "Download this lab (12 MB)". */
function scriptBytes(script) {
    return script.assets.reduce((total, asset) => total + asset.bytes, 0);
}
function findDataset(script, datasetId) {
    return script.datasets.find(dataset => dataset.id === datasetId);
}
function findStep(script, stepId) {
    return script.steps.find(step => step.id === stepId);
}
//# sourceMappingURL=pure.js.map